import { render } from "./SubCategorySchemajson.vue?vue&type=template&id=115dbfc2"
import script from "./SubCategorySchemajson.vue?vue&type=script&lang=js"
export * from "./SubCategorySchemajson.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__